import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import InputDisplay from "./InputDisplay";


const styles = theme => ({
  stepTitle: {
    marginTop: 10,
    marginBottom: 10
  },
});

class TerminalDetails extends React.Component {

  render() {
    const { classes, title, terminalData } = this.props;

    return (
      <div>
        <Typography variant="title" component="h3" className={classes.stepTitle}>{title}</Typography>
        <InputDisplay idName="terminalCodeInput" labelText="Koodi" value={terminalData.terminalCode} isDisabled={true} /> 
        <InputDisplay idName="commentInput" labelText="Kommentti" value={terminalData.comment} isDisabled={true} /> 
      </div>
    );
  }
}


export default withStyles(styles)(TerminalDetails);



// WEBPACK FOOTER //
// ./src/components/Steps/TerminalDetails.js